import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { ProspectSettingsRouter } from './settings/_router'

const Index = lazy(() => import('./Index'))
const List = lazy(() => import('./List'))
const New = lazy(() => import('./New'))
const Detail = lazy(() => import('./:id/Index'))

export const ProspectsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--members--prospects']}>
    <Route index element={<Index />} />
    <Route path='list' element={<List />} />
    <Route path='new' element={<New />} />
    <Route path='settings/*' element={<ProspectSettingsRouter />} />
    <Route path=':id/*' element={<Detail />} />
  </SubRouter>
))
